import * as Yup from 'yup';
export const idSchema = Yup
    .number()
    .required('Id поле обов\'язкове')
    .integer('Id повинно бути цілим числом')
    .positive('Id повинно бути позитивним числом');
